var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,16.851c-7.065,0-12.814,5.749-12.814,12.814c0,6.386,4.695,11.696,10.814,12.659v34.825c0,1.104,0.896,2,2,2 s2-0.896,2-2V42.324c6.119-0.963,10.814-6.273,10.814-12.659C60.814,22.6,55.065,16.851,48,16.851z M48,38.479 c-4.86,0-8.814-3.954-8.814-8.814c0-4.86,3.954-8.814,8.814-8.814c4.86,0,8.814,3.954,8.814,8.814 C56.814,34.525,52.86,38.479,48,38.479z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.5b46a0deed706c507b08a0784674a2a6.svg";
export { ForwardRef as ReactComponent };